/*
 * flagship.js
 * Main Flagship frontend class to manage core functionality
 */

import axios from 'axios';
import queryString from 'query-string';
import store from '../store/store';
import config from '../constants/config';
import {browserHistory} from 'react-router';
import * as types from '../constants/actionTypes';

class Flagship {

    constructor() {

        let envConfig = {
            "env": "dev",
            "apiBase": "http://flagship.api/",
            "uploads": "https://flagship-user-photos.s3.amazonaws.com/",
            "awsBucket": "dev-flagship-crm",
            "url": "http://" + window.location.hostname
        };

        if (window.location.hostname === "dev.flagship.2060digital.com" || window.location.hostname === "new.flagship.2060digital.com" || window.location.hostname === "flagship.2060digital.com") {
            envConfig = {
                "env": "production",
                "apiBase": "https://api.flagship.2060digital.com/",
                "uploads": "https://flagship-user-photos.s3.amazonaws.com/",
                "awsBucket": "dev-flagship-crm",
                "url": "https://" + window.location.hostname
            }
        } else if (window.location.hostname === "test.flagship.2060digital.com") {
            envConfig = {
                "env": "staging",
                "apiBase": "https://api.test.flagship.2060digital.com/",
                "uploads": "https://flagship-user-photos.s3.amazonaws.com/",
                "awsBucket": "dev-flagship-crm",
                "url": "https://" + window.location.hostname
            }
        }

        this.config = Object.assign(config, envConfig);
    }

    get( endpoint, query, callback, error ) {

        let token = localStorage.getItem("flagshipToken");

        store.dispatch({
            type: types.BEGIN_REQUEST,
        });

        let url = this.config.apiBase + endpoint + ( query !== {} ? '?' + queryString.stringify(query) : '' );

        let config = {
            headers: {"X-Flagship-Token" : token}
        };

        let result = new Promise(resolve => {
            let r = resolve;
            axios.get(url, config).then(function (response) {

                store.dispatch({
                    type: types.END_REQUEST,
                });

                if (typeof callback === "function") {
                    callback(response);
                }
                r(true);
            }).catch(function(err) {

                store.dispatch({
                    type: types.END_REQUEST,
                });

                if (typeof error === "function") {
                    error(err);
                }
                return false;
            });
            return result;
        });
    }


    post( endpoint, data, callback, error, ignoreToken = false ) {

        let token = localStorage.getItem("flagshipToken");


        if (token === null && ignoreToken !== true) {
            return false;
        }

        let self = this;

        store.dispatch({
            type: types.BEGIN_REQUEST,
        });

        let url = this.config.apiBase + endpoint;
        let config = {
            headers: {
                "X-Flagship-Token" : token,
                "Content-Type" : "application/x-www-form-urlencoded"
            },
            "X-Flagship-Token" : token,
            ...data
        };

        let result = new Promise(resolve => {
            let r = resolve;

            axios.post(url,config).then( function(response) {

                store.dispatch({
                    type: types.END_REQUEST,
                });

                if (typeof callback === "function") {
                    callback(response);
                }
                r(true);
            }).catch( function(err) {

                store.dispatch({
                    type: types.END_REQUEST,
                });

                if (typeof error === "function") {
                    error(err);
                } else {
                    self.notify("An API error occurred.", "error");
                }
                return false;
            });
        });

        return result;
    }

    log(action, data = '', target = null, user = null) {

        let logData = {
            action,
            data,
            target,
            user
        };

        this.post('log/write', logData);
    }

    notify(message, type = "info") {
        store.dispatch({
            type: types.SET_NOTIFICATION,
            payload: {
                type,
                message
            }
        });
    }

    event(action, data = '', target = null, user = null) {

        this.log(action, data, target, user);
        this.sendMail(action, data, target, user);
    }

    error(message, target, user) {
        this.log("error", message, target, user);
        this.notify(message, "error");
    }

    closeSidebarNav() {
        store.dispatch(
                {
                    type: types.CLOSE_SIDEBAR_NAV
                }
            );
    }

    toggleSidebarNav() {
        store.dispatch(
            {
                type: types.TOGGLE_SIDEBAR_NAV
            }
        );
    }

    redirect(path) {
        browserHistory.push(path);
    }

    changeRecordStatus(record, status, callback) {
        this.post(
            'change-record-status/' + record + '/' + status,
            {},
            function(response) {
                if ( typeof callback === "function" ) {
                    callback(response);
                }
            }
        );
    }

    sendMail(action, data, target, user, callback) {

        let self = this;

        let style = 'display:inline-block; padding:6px 12px; color:#ffffff; border-radius:5px; ';

        // Prepare certain data for server-side (where action involves status change & config is not available)
        if (action === 'change-status-io') {

            switch( this.config.records.io.statuses[data].color ) {

                case 'green':
                    style += 'background-color:#21BA45;';
                    break;

                case 'blue':
                    style += 'background-color:#2185D0;';
                    break;

                case 'purple':
                    style += 'background-color:#a333c8;';
                    break;
                case 'orange':
                    style+= 'background-color:#f2711c;';
                    break;
                case 'yellow':
                    style+= 'background-color:#FBBD08;';
                    break;
                case 'red':
                    style+= 'background-color:#DB2828;';
                    break;
                default:
                    style += 'background-color:#333';
                    break;
            }
            data = '<span class="status-label" style="' + style + '">' + this.config.records.io.statuses[data].label + '</span>';
        }  else if (action === 'change-status-rfp') {

            switch( this.config.records.rfp.statuses[data].color ) {

                case 'green':
                    style += 'background-color:#21BA45;';
                    break;

                case 'blue':
                    style += 'background-color:#2185D0;';
                    break;

                case 'purple':
                    style += 'background-color:#a333c8;';
                    break;
                case 'orange':
                    style+= 'background-color:#f2711c;';
                    break;
                case 'yellow':
                    style+= 'background-color:#FBBD08;';
                    break;
                case 'red':
                    style+= 'background-color:#DB2828;';
                    break;
                default:
                    style += 'background-color:#333';
                    break;
            }
            data = '<span class="status-label" style="' + style + '">' + this.config.records.rfp.statuses[data].label + '</span>';
        } else if (action === 'proposal-upload') {

            style = 'display:inline-block;padding:6px 12px; color:#ffffff; border-radius:5px; background-color:#a333c8;';

            let filename = data;
            data = {
                filename: filename,
                label: '<span class="status-label" style="' + style + '">Proposal</span>'
            };
        }

        this.post(
            'mail/' + action,
            {
                record_id: target,
                user_id: user,
                data: data,
                config: self.config
            },
            function(response) {

                if (response.success !== true) {
                    self.log("error", "Error sending mail (action: " + action + ").");
                }
                if ( typeof callback === "function" ) {
                    callback(response);
                }
            },function(err) {
                self.log("error", "Error sending mail (action: " + action + ", error: " + err + ").");
            }
        );
    }

    setFormTemplate(data, callback) {
        store.dispatch({
            type: types.SET_FORM_TEMPLATE,
            payload: {
                data
            }
        });
        if (typeof callback === "function") {
            callback();
        }
    }

    clearFormTemplate(callback) {
        store.dispatch({
            type: types.CLEAR_FORM_TEMPLATE,
            payload: {}
        });
        if (typeof callback === "function") {
            callback();
        }
    }

}

export default new Flagship();


// WEBPACK FOOTER //
// ./src/core/flagship.js